import { createAction } from "redux-actions";

export const isLoadingTenantsAction = createAction("isLoadingTenantsAction");
export const storeTenantsAction = createAction("storeTenantsAction");